import type { SxProps } from '@mui/material/styles';

export const itemStyles = ({ isSelected }: { isSelected: boolean }): SxProps => ({
  padding: 1.5,
  opacity: isSelected ? 0.6 : 1,
  transition: 'opacity 0.2s ease',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  paddingLeft: 2,

  '& .segment-list-item .icon-button': {
    visibility: 'hidden',
  },

  ':hover': {
    backgroundColor: 'background.boxDarker',

    '& .segment-list-item .icon-button': {
      visibility: 'visible',
    },
  },
});

export const expandIconStyles = (expanded: boolean): SxProps => ({
  transition: 'transform 0.2s ease',
  transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
  color: expanded ? 'primary.main' : 'text.secondary',
});

export const basicInfoBoxStyles: SxProps = {
  ml: 4,
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
  rowGap: 0,
};

export const labelValuePairStyles: SxProps = {
  display: 'flex',
  alignItems: 'center',
  mr: 0.5,
};

export const labelStyles: SxProps = {
  color: 'text.secondary',
  mr: 0.5,
};

export const categoryBoxStyles: SxProps = {
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: 0,
};
